import React, { useContext, useEffect, useState } from "react";
import * as Components from "../../../../component";
import * as Style from "../../../../component/style/content/default";
import * as Services from "../../../../service";
import { Method } from "../../../../service";
import { CompanyInactive, Header } from "./components";
import { Form } from "react-bootstrap";
import moment from "moment";

const DAY_OPTIONS = [
  { label: "Minggu", value: "0" },
  { label: "Senin", value: "1" },
  { label: "Selasa", value: "2" },
  { label: "Rabu", value: "3" },
  { label: "Kamis", value: "4" },
  { label: "Jumat", value: "5" },
  { label: "Sabtu", value: "6" },
];

const CHANNEL_OPTIONS = ["ONLINE", "OFFLINE"];

const INITIAL_POINT = {
  type: "",
  value: "",
  amount: ""
};

const INITIAL_DOUBLE_POINT = {
  status: false,
  days: [],
  startTime: "",
  endTime: "",
  channels: [],
  multiplier: "2"
};

const normalizeArray = (value) => {
  if (Array.isArray(value)) return value;

  if (typeof value === "string") {
    const clean = value.trim();
    if (!clean) return [];

    try {
      const parsed = JSON.parse(clean);
      if (Array.isArray(parsed)) return parsed;
    } catch (error) {
      return clean.split(",").map((item) => item.trim()).filter(Boolean);
    }
  }

  return [];
};

const normalizeDateInput = (value) => {
  if (!value) return "";

  const parsed = moment(value);
  if (!parsed.isValid()) return "";

  return parsed.format("YYYY-MM-DDTHH:mm");
};

const normalizeTimeInput = (value) => {
  if (!value) return "";

  const clean = `${value}`.trim();
  if (/^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(clean)) return clean.slice(0, 5);
  if (/^([01]\d|2[0-3]):[0-5]\d$/.test(clean)) return clean;

  return "";
};

const normalizeTimeApi = (value) => {
  if (!value) return "";

  const clean = `${value}`.trim();
  if (/^([01]\d|2[0-3]):[0-5]\d$/.test(clean)) return `${clean}:00`;
  if (/^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(clean)) return clean;

  return "";
};

export default function LoyaltyGetPoint() {
  const { selected_company } = useContext(Services.Context);
  const [allow, setAllow] = useState(false)
  const [status, setStatus] = useState(false)
  const [point, setPoint] = useState(INITIAL_POINT)
  const [doublePoint, setDoublePoint] = useState(INITIAL_DOUBLE_POINT)
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isDate, setIsDate] = useState(true);
  const [loading, setLoading] = useState(false);

  const getConfig = async () => {
    await Method.get(`loyalty/conf/company/${selected_company.value}`)
    .then(async (res) => {
      if (res?.data?.status) {
        setAllow(true)
      }else{
        if(res?.data?.error === "not_found"){
          setAllow(false)
        }
      }
    })
  }

  const getRuleTransaction = async () => {
    await Method.get(`loyalty/rules/company/${selected_company.value}/transaction`)
    .then(async (res) => {
      if (res?.data?.status) {
        const data = res.data.data || {};

        setPoint({
          type: data.point_type,
          value: data.value,
          amount: data.amount
        })

        setStatus(parseInt(data.status, 10) === 1)
        setIsDate(parseInt(data.is_timeless, 10) === 1)
        setStartDate(normalizeDateInput(data.start_date || data.startDate))
        setEndDate(normalizeDateInput(data.end_date || data.endDate))

        const normalizedDayList = normalizeArray(data.double_point_days || data.doublePointDays)
          .map((row) => `${parseInt(row, 10)}`)
          .filter((row) => row !== "NaN");

        const normalizedChannelList = normalizeArray(data.double_point_channels || data.doublePointChannels)
          .map((row) => `${row}`.trim().toUpperCase())
          .filter((row) => CHANNEL_OPTIONS.includes(row));

        const multiplierRaw = data.double_point_multiplier ?? data.doublePointMultiplier ?? 2;
        const multiplierNumber = parseFloat(multiplierRaw);

        setDoublePoint({
          status: parseInt(data.double_point_status || data.doublePointStatus || 0, 10) === 1,
          days: normalizedDayList,
          startTime: normalizeTimeInput(data.double_point_start_time || data.doublePointStartTime),
          endTime: normalizeTimeInput(data.double_point_end_time || data.doublePointEndTime),
          channels: normalizedChannelList,
          multiplier: Number.isFinite(multiplierNumber) && multiplierNumber > 0 ? `${multiplierNumber}` : "2"
        });
      }else{
        setPoint(INITIAL_POINT)
        setDoublePoint(INITIAL_DOUBLE_POINT)
        setStatus(false)
        setIsDate(true)
        setStartDate("")
        setEndDate("")
      }
    })
  }

  const submitTransaction = () => {
    Components.AlertQuestion({
      title: "Ubah Data",
      text: "Apakah anda yakin mau mengubah data ini",
    }).then((res) => {
      if (res.isConfirmed) {
        //action
        processTransaction()
      }
    });
  }

  const processTransaction = async () => {
    setLoading(true);

    if (doublePoint.status) {
      const multiplierNumber = parseFloat(doublePoint.multiplier);

      if (!Number.isFinite(multiplierNumber) || multiplierNumber <= 0) {
        Components.AlertError({ title: "Error", text: "Multiplier point harus angka lebih dari 0" });
        setLoading(false);
        return;
      }

      if (doublePoint.days.length === 0) {
        Components.AlertError({ title: "Error", text: "Pilih minimal satu hari untuk double point" });
        setLoading(false);
        return;
      }

      if (!doublePoint.startTime || !doublePoint.endTime) {
        Components.AlertError({ title: "Error", text: "Jam mulai dan jam selesai double point wajib diisi" });
        setLoading(false);
        return;
      }

      if (doublePoint.channels.length === 0) {
        Components.AlertError({ title: "Error", text: "Pilih minimal satu channel untuk double point" });
        setLoading(false);
        return;
      }
    }

    let dataForm = {
      point_type: point.type,
      value: point.value,
      status: status ? "1" : "0",
      is_timeless: isDate ? "1" : "0",
      double_point_status: doublePoint.status ? "1" : "0",
      double_point_days: doublePoint.days,
      double_point_start_time: normalizeTimeApi(doublePoint.startTime),
      double_point_end_time: normalizeTimeApi(doublePoint.endTime),
      double_point_channels: doublePoint.channels,
      double_point_multiplier: doublePoint.multiplier ? `${parseFloat(doublePoint.multiplier)}` : "2"
    }

    if(point.type === "fixed_purchase_min" || point.type === "fixed_multiple"){
      dataForm['amount'] = point.amount;
    }

    if(!isDate){
      dataForm['start_date'] = startDate ? moment(startDate).format("YYYY-MM-DD HH:mm:ss") : ""
      dataForm['end_date'] = endDate ? moment(endDate).format("YYYY-MM-DD HH:mm:ss") : ""
    }

    await Method.post(`loyalty/rules/company/${selected_company.value}/transaction`, dataForm)
    .then(async (res) => {
      if (res?.data?.status) {
        Components.AlertSuccess({ title: "Success", text: res?.data?.message });
      }else{
        Components.AlertError({ title: "Error", text: res?.data?.error });
      }
    }).finally(() => {
      setLoading(false)
    })
  }

  const toggleDoublePointDay = (dayValue) => {
    const currentDays = doublePoint.days || [];
    const exists = currentDays.includes(dayValue);

    const nextDays = exists
      ? currentDays.filter((row) => row !== dayValue)
      : [...currentDays, dayValue];

    nextDays.sort((a, b) => parseInt(a, 10) - parseInt(b, 10));

    setDoublePoint({
      ...doublePoint,
      days: nextDays
    });
  };

  const toggleDoublePointChannel = (channel) => {
    const currentChannels = doublePoint.channels || [];
    const exists = currentChannels.includes(channel);

    const nextChannels = exists
      ? currentChannels.filter((row) => row !== channel)
      : [...currentChannels, channel];

    setDoublePoint({
      ...doublePoint,
      channels: nextChannels
    });
  };

  useEffect(() => {
    if (selected_company.value) {
      // get config detail
      getConfig()
      getRuleTransaction()
    }
  }, [selected_company.value]);

  if(!allow){
    return(
      <Style.ContainerContent>
        <Header title="Perolehan Point"/>
        <CompanyInactive/>
      </Style.ContainerContent>
    )
  }

  return (
    <Style.ContainerContent>
      <Header title="Perolehan Point"/>

      <section className="mt-5">
        <div className="row">
          <h5 className="col-md-12 mb-3"><strong>Transaksi</strong></h5>
          <div className="col-md-3">
            <Style.Label color={Style.COLOR_SECONDARY}><b>Point Diberikan</b></Style.Label>
            <p>Pilih nilai unit yang digunakan dalam perhitungan</p>
          </div>
          <div className="col-md-9 mb-3">
            <div className="d-flex flex-row align-items-center mb-2">
              <Form.Check
                type={'radio'}
                checked={point.type === "percentage"}
                onChange={() => setPoint({...point, type: 'percentage'})}
                disabled={loading}
              />
              <div className="ms-2" style={{width:135}}>
                <div><strong>Persentasi:</strong> Beri</div>
              </div>
              <input
                type="number"
                className="form-control ms-2"
                style={{width:80}}
                value={point.type === "percentage" ? point.value : ""}
                min="1"
                max="100"
                onChange={(e) => {
                  let { value, min, max } = e.target;
                  const res = Math.max(min, Math.min(max, Number(value)));
                  setPoint({...point, value: res})
                }}
                disabled={loading || point.type !== "percentage"}
              />
              <div className="ms-2">% dari total pembelian</div>
            </div>

            <div className="d-flex flex-row align-items-center mb-2">
              <Form.Check
                type={'radio'}
                checked={point.type === "fixed_every_purchase"}
                onChange={() => setPoint({...point, type: 'fixed_every_purchase'})}
                disabled={loading}
              />
              <div className="ms-2" style={{width:135}}>
                <div><strong>Jumlah tetap:</strong> Beri</div>
              </div>
              <input
                type="number"
                className="form-control ms-2"
                style={{width:80}}
                value={point.type === "fixed_every_purchase" ? point.value : ""}
                min="1"
                onChange={(e) => {
                  let { value, min } = e.target;
                  const res = Math.max(min, Number(value));
                  setPoint({...point, value: res})
                }}
                disabled={loading || point.type !== "fixed_every_purchase"}
              />
              <div className="ms-2">point setiap pembelian</div>
            </div>
            <div className="d-flex flex-row align-items-center mb-2">
              <Form.Check
                type={'radio'}
                checked={point.type === "fixed_purchase_min"}
                onChange={() => setPoint({...point, type: 'fixed_purchase_min'})}
                disabled={loading}
              />
              <div className="ms-2" style={{width:135}}>
                <div><strong>Jumlah tetap:</strong> Beri</div>
              </div>
              <input
                type="number"
                className="form-control ms-2"
                style={{width:80}}
                value={point.type === "fixed_purchase_min" ? point.value : ""}
                min="1"
                onChange={(e) => {
                  let { value, min } = e.target;
                  const res = Math.max(min, Number(value));
                  setPoint({...point, value: res})
                }}
                disabled={loading || point.type !== "fixed_purchase_min"}
              />
              <div className="ms-2">point setiap pembelian minimal</div>
              <input
                type="number"
                className="form-control ms-2"
                style={{width:100}}
                value={point.type === "fixed_purchase_min" ? point.amount : ""}
                min="1"
                onChange={(e) => {
                  let { value, min } = e.target;
                  const res = Math.max(min, Number(value));
                  setPoint({...point, amount: res})
                }}
                disabled={loading || point.type !== "fixed_purchase_min"}
              />
              <div className="ms-2">RUPIAH</div>
            </div>
            <div className="d-flex flex-row align-items-center mb-2">
              <Form.Check
                type={'radio'}
                checked={point.type === "fixed_multiple"}
                onChange={() => setPoint({...point, type: 'fixed_multiple'})}
                disabled={loading}
              />
              <div className="ms-2" style={{width:135}}>
                <div><strong>Jumlah tetap:</strong> Beri</div>
              </div>
              <input
                type="number"
                className="form-control ms-2"
                style={{width:80}}
                value={point.type === "fixed_multiple" ? point.value : ""}
                min="1"
                onChange={(e) => {
                  let { value, min } = e.target;
                  const res = Math.max(min, Number(value));
                  setPoint({...point, value: res})
                }}
                disabled={loading || point.type !== "fixed_multiple"}
              />
              <div className="ms-2">point setiap kelipatan</div>
              <input
                type="number"
                className="form-control ms-2"
                style={{width:100}}
                value={point.type === "fixed_multiple" ? point.amount : ""}
                min="1"
                onChange={(e) => {
                  let { value, min } = e.target;
                  const res = Math.max(min, Number(value));
                  setPoint({...point, amount: res})
                }}
                disabled={loading || point.type !== "fixed_multiple"}
              />
              <div className="ms-2">RUPIAH saat pembelian</div>
            </div>
          </div>
          <div className="col-md-3">
            <Style.Label color={Style.COLOR_SECONDARY}><b>Status</b></Style.Label>
          </div>
          <div className="col-md-9 mb-3">
            <Form.Check
              type="switch"
              label={status?"Aktif":"Tidak Aktif"}
              checked={status}
              onChange={() => setStatus(!status)}
              disabled={loading}
            />
          </div>
          <div className="col-md-3">
            <Style.Label color={Style.COLOR_SECONDARY}><b>Tangal Mulai/Berakhir</b></Style.Label>
            <p>Tentukan berapa lama aturan ini aktif</p>
          </div>
          <div className="col-md-9 mb-3">
            <div className="d-flex flex-row">
              <div className="mb-3">
                <Style.Label color={Style.COLOR_SECONDARY}>Dari Tanggal</Style.Label>
                <input
                  style={{maxWidth:200}}
                  type="datetime-local"
                  className="form-control"
                  onChange={(e) => setStartDate(e.target.value)}
                  value={startDate}
                  disabled={isDate || loading}
                />
              </div>
              <div className="mb-3 ms-3">
                <Style.Label color={Style.COLOR_SECONDARY}>Sampai Tanggal</Style.Label>
                <input
                  style={{maxWidth:200}}
                  type="datetime-local"
                  className="form-control"
                  onChange={(e) => setEndDate(e.target.value)}
                  min={startDate}
                  value={endDate}
                  disabled={isDate || loading}
                />
              </div>
            </div>
            <Form.Check
              type={'checkbox'}
              checked={isDate}
              onChange={() => setIsDate(!isDate)}
              label="Tanpa batas waktu"
              disabled={loading}
            />
          </div>

          <div className="col-md-3">
            <Style.Label color={Style.COLOR_SECONDARY}><b>Double Point</b></Style.Label>
            <p>Atur hari, jam, dan channel untuk poin ganda</p>
          </div>
          <div className="col-md-9 mb-3">
            <Form.Check
              type="switch"
              label={doublePoint.status ? "Aktif" : "Tidak Aktif"}
              checked={doublePoint.status}
              onChange={() => setDoublePoint({ ...doublePoint, status: !doublePoint.status })}
              disabled={loading}
            />

            <div className="mt-3">
              <Style.Label color={Style.COLOR_SECONDARY}>Multiplier Point</Style.Label>
              <input
                style={{maxWidth:160}}
                type="number"
                step="0.1"
                min="0.1"
                className="form-control"
                value={doublePoint.multiplier}
                onChange={(e) => setDoublePoint({ ...doublePoint, multiplier: e.target.value })}
                disabled={loading || !doublePoint.status}
              />
              <small className="text-muted">Contoh: 1.5, 2, 3, 4</small>
            </div>

            <div className="mt-3">
              <Style.Label color={Style.COLOR_SECONDARY}>Hari Berlaku</Style.Label>
              <div className="d-flex flex-wrap">
                {DAY_OPTIONS.map((day) => (
                  <Form.Check
                    key={day.value}
                    type="checkbox"
                    className="me-3 mb-2"
                    label={day.label}
                    checked={doublePoint.days.includes(day.value)}
                    onChange={() => toggleDoublePointDay(day.value)}
                    disabled={loading || !doublePoint.status}
                  />
                ))}
              </div>
            </div>

            <div className="d-flex flex-row mt-2">
              <div className="mb-3">
                <Style.Label color={Style.COLOR_SECONDARY}>Dari Jam</Style.Label>
                <input
                  style={{maxWidth:160}}
                  type="time"
                  className="form-control"
                  value={doublePoint.startTime}
                  onChange={(e) => setDoublePoint({ ...doublePoint, startTime: e.target.value })}
                  disabled={loading || !doublePoint.status}
                />
              </div>
              <div className="mb-3 ms-3">
                <Style.Label color={Style.COLOR_SECONDARY}>Sampai Jam</Style.Label>
                <input
                  style={{maxWidth:160}}
                  type="time"
                  className="form-control"
                  value={doublePoint.endTime}
                  onChange={(e) => setDoublePoint({ ...doublePoint, endTime: e.target.value })}
                  disabled={loading || !doublePoint.status}
                />
              </div>
            </div>

            <div className="mt-2">
              <Style.Label color={Style.COLOR_SECONDARY}>Channel Transaksi</Style.Label>
              <div className="d-flex flex-wrap mt-1">
                {CHANNEL_OPTIONS.map((channel) => (
                  <Form.Check
                    key={channel}
                    type="checkbox"
                    className="me-3 mb-2"
                    label={channel}
                    checked={doublePoint.channels.includes(channel)}
                    onChange={() => toggleDoublePointChannel(channel)}
                    disabled={loading || !doublePoint.status}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <Style.ButtonPrimary
              onClick={() => submitTransaction()}
              disabled={loading ? true : false}
            >
              {
                loading ? (
                  <><Components.LoadingIcon /> Loading...</>
                ) : (
                  <>Simpan</>
                )
              }
            </Style.ButtonPrimary>
          </div>
        </div>
      </section>
    </Style.ContainerContent>
  );
}
